<template>
  <div
    class="top-categories-widget-view"
    :style="style"
  >
    <div class="widget-wrapper">
      <div
        class="categories-container"
        :class="{ 'no-data': !hasRealData }"
      >
        <div
          v-for="(category, index) in displayData"
          :key="index"
          class="category-item"
          :style="{
            width: widget.cardWidth + '%',
            marginBottom: widget.gap + 'px',
            boxShadow: widget.boxShadow
          }"
        >
          <span
            class="category-label"
            :style="{
              color: widget.textColor,
              fontSize: widget.fontSize + 'px'
            }"
          >{{ category.categoryLabel }}</span>
          <span
            class="category-amount"
            :style="{
              color: widget.textColor,
              fontSize: widget.fontSize + 'px'
            }"
          >£{{ numberToHumanReadable(Math.round(category.averageSpending)) }}</span>
        </div>
      </div>
    </div>

    <!-- Overlay box when no real data -->
    <div
      v-if="!hasRealData"
      class="no-data-overlay"
    >
      <div class="overlay-content">
        <div class="overlay-text">
          We don't have enough data to display your Top categories.
          <span
            class="connect-link"
            @click="handleConnectAccountsClick"
          >connect an active account</span>
          to get the full picture
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'TopCategoriesWidgetView',
  props: {
    widget: {
      type: Object,
    },
  },
  computed: {
    style() {
      return {
        top: `${this.widget.top}px`,
        zIndex: this.widget.zIndex,
        fontFamily: this.widget.fontFamily,
      };
    },
    hasRealData() {
      const data = this.widget.variableData;
      return data && Array.isArray(data) && data.length > 0;
    },
    displayData() {
      if (this.hasRealData) {
        // Limit to the specified amount
        return this.widget.variableData.slice(0, this.widget.categoriesAmount);
      }
      // Return default placeholder data when no real data
      const placeholderCount = Math.min(this.widget.categoriesAmount || 3, 3);
      return Array(placeholderCount).fill().map((_, index) => ({
        categoryLabel: 'No categories found',
        averageSpending: 0,
      }));
    },
    variableData() {
      // Keep this for backward compatibility if needed elsewhere
      return this.displayData;
    },
  },
  methods: {
    handleConnectAccountsClick() {
      this.$emit('userInteraction', {
        eventName: 'connectAccountsClicked',
      });
    },
    numberToHumanReadable(num) {
      if (typeof num !== 'number') { return num; }

      return num.toLocaleString('en-GB', {
        maximumFractionDigits: 0,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.top-categories-widget-view {
  position: absolute;
  display: flex;
  width: 430px;
  left: 0;

  .widget-wrapper {
    width: 100%;
    margin-right: 30px;
    margin-left: 30px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
}

.categories-container {
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;

  &.no-data {
    opacity: 0.4; /* Fade the categories when no real data */
    pointer-events: none; /* Disable all interactions */
  }
}

.category-item {
  background-color: white;
  border-radius: 20px;
  padding: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
}

.category-label {
  // Font family will be inherited from the widget container
}

.category-amount {
  font-weight: bold;
}

.no-data-overlay {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 10;
  pointer-events: none; /* Allow clicks to pass through */

  .connect-link {
    pointer-events: auto; /* Enable clicks on the connect link */
  }
}

.overlay-content {
  background: linear-gradient(135deg, #F5D547 0%, #FFCE00 100%);
  border-radius: 20px;
  padding: 20px 25px;
  width: 360px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1);
}

.overlay-text {
  color: #1a365d;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
  text-align: center;
  word-wrap: break-word;
  overflow-wrap: break-word;
  white-space: normal;
}

.connect-link {
  color: #2563eb;
  text-decoration: underline;
  font-weight: 700;
  cursor: pointer;
}
</style>
